window.Reverb = window.Reverb || {};
Reverb.Shipping = Reverb.Shipping || {};

Reverb.Shipping.ShippingProfilesSelect = (function () {
  const profilesSelect = '[data-shipping-profile-url]';

  function init() {
    setShippingInfo();
    bindSelectChange();
  }

  function setShippingInfo() {
    const $select = $(profilesSelect);
    const selected = $select.val();
    if (selected) {
      $($select.data('custom-shipping')).hide();
      $($select.data('shipping-profile-details')).show().spin();
      setProfile(selected, $select);
    } else {
      $($select.data('shipping-profile-details')).hide().html('');
      $($select.data('custom-shipping')).show();
    }
  }

  function bindSelectChange() {
    $(profilesSelect).on('change', setShippingInfo);
  }

  function setProfile(selected, $select) {
    $.get($select.data('shipping-profile-url'), { id: selected })
      .done((response) => {
        $($select.data('shipping-profile-details')).html(response);
      });
  }

  return {
    init,
  };
}());

$(document).ready(Reverb.Shipping.ShippingProfilesSelect.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/shipping/shipping_profile_select.js